module.exports = __webpack_public_path__ + "static/shop-1b580ca6481e5238cfcca3d8c5b9f95f.jpg";